<section class="bg-white p-6">
  <!-- title -->
  <h1 class="text-xl font-bold text-dc-navy mb-6 border-b border-gray-300 pb-3">
    {{ "DIR.TITLE" | translate }}
  </h1>

  <!-- search + count -->
  <div class="flex flex-wrap items-center gap-4 border-b border-gray-300 mb-5">
    <form
      class="w-full sm:w-72 mb-5"
      [formGroup]="form"
      (ngSubmit)="getDirectoryList(form.value.search)"
    >
      <div class="flex items-center border border-gray-300 overflow-hidden">
        <input
          type="text"
          formControlName="search"
          [placeholder]="'DIR.SEARCH.LABEL' | translate"
          class="flex-grow px-4 py-2 text-sm focus:outline-none"
        />
        <button type="submit" class="px-4 text-dc-navy">
          <i class="fas fa-search"></i>
        </button>
      </div>
    </form>

    @if (totalRecords && totalRecords > 0) {
    <span class="text-sm text-dc-black mb-5 font-semibold">
      {{ "DIR.COUNT" | translate : { n: totalRecords } }}
    </span>
    } @if (loading) {
    <span class="text-sm text-dc-black mb-5 font-semibold">
      {{ "LOADING" | translate }}
    </span>
    }
  </div>

  <table class="dc-table">
    <thead>
      <th class="ltr:text-left! rtl:text-right!">
        {{ "DIR.COL.MEMBERSHIP" | translate }}
      </th>
      <th class="ltr:text-left! rtl:text-right!">
        {{ "DIR.COL.NAME" | translate }}
      </th>
      <th class="text-center!">{{ "DIR.COL.EMAIL" | translate }}</th>
      <th class="text-center!">{{ "DIR.COL.PHONE" | translate }}</th>
    </thead>
    <tbody>
      @if (loading) { @for (_ of [].constructor(pageSize); track $index) {
      <tr class="divide-x divide-slate-300 border-b border-slate-200">
        @for (__ of [].constructor(4); track $index) {
        <td class="p-4">
          <span
            class="block h-3 w-full rounded bg-slate-200 animate-pulse"
          ></span>
        </td>
        }
      </tr>
      } }@else{ @for (row of rows; track $index) {
      <tr>
        <td class="ltr:text-left! rtl:text-right!">
          <span class="font-semibold text-dc-black">{{ row.membership }}</span>
        </td>
        <td class="ltr:text-left! rtl:text-right!">
          <span class="font-semibold text-dc-black">{{ row.name }}</span>
        </td>
        <td class="text-center!">{{ row.email }}</td>
        <td class="text-center!">{{ row.phone }}</td>
      </tr>
      } } @if (!loading && (!rows || rows.length < 1)) {
      <tr>
        <td class="text-center! py-4 text-dc-gray-light italic" colspan="4">
          @if (!dataFetched) {
          {{ "DIR.SEARCH.MESSAGE" | translate }}
          } @else {
          {{ "NO_RECORD_FOUND" | translate }} @if (lastSearchTerm) { "{{
            lastSearchTerm
          }}" } }
        </td>
      </tr>
      }
    </tbody>
  </table>
  @if (!loading && totalPages > 1) {
  <app-table-pagenation
    [currentPage]="currentPage"
    [totalPages]="totalPages"
    (prev)="changePage(currentPage - 1)"
    (next)="changePage(currentPage + 1)"
    (goToPage)="changePage($event)"
  ></app-table-pagenation>
  }
</section>
